import React from 'react';
import { IonCard, IonCardContent } from '@ionic/react';

export interface ProCardProps {
  children: React.ReactNode;
  /**
   * When true, wraps children in an IonCardContent (the default Ionic 16px
   * padding). Leave false for row-stacking cards that supply their own
   * per-row padding (e.g. ProListRow).
   */
  padded?: boolean;
  /**
   * When true, clips inner content to the card radius — used by dashboard widgets
   * (Latest News, etc.) via the `pro-card-clipped` class in pro-ionic.css.
   */
  clipContent?: boolean;
  /** Class applied to the outer IonCard. */
  className?: string;
  /** Class applied to the inner IonCardContent (only when `padded`). */
  contentClassName?: string;
}

const ProCard: React.FC<ProCardProps> = ({
  children,
  padded = false,
  clipContent = false,
  className,
  contentClassName,
}) => (
  <IonCard
    className={[clipContent && 'pro-card-clipped overflow-hidden', className]
      .filter(Boolean)
      .join(' ')}
  >
    {padded ? (
      <IonCardContent
        className={[clipContent && 'overflow-hidden', contentClassName].filter(Boolean).join(' ')}
      >
        {children}
      </IonCardContent>
    ) : (
      children
    )}
  </IonCard>
);

export default ProCard;
